import React from "react";
import { useSelector } from "react-redux";
import PieChart from "../../Core/Components/PieChart";
import SolarIcon from "../../Common/Svgs/SolarIcon";
import PowerGridIcon from "../../Common/Svgs/PowerGridIcon";
import EnergyStoredIcon from "../../Common/Svgs/EnergyStoredIcon";
import EnergyConsumedIcon from "../../Common/Svgs/EnergyConsumedIcon";
import getFormatedFloat from "../../Utils/getFormatedFloat";

const Container = ({ title, icon }) => {
  const { kpi } = useSelector((state) => state.hubs);

  const getValue = () => {
    if (title === "total energy produced") return kpi.totalEnergyProduced;

    if (title === "total energy stored")
      return kpi.totalEnergyStoredInSolar + kpi.totalEnergyStoredInGrid;

    if (title === "total energy consumed")
      return kpi.totalEnergyConsumedBySolar + kpi.totalEnergyConsumedByGrid;

    return "--";
  };

  const getPieChartData = () => {
    if (title === "total energy stored") {
      const total = kpi.totalEnergyStoredInSolar + kpi.totalEnergyStoredInGrid;

      const solar = (kpi.totalEnergyStoredInSolar / total) * 100;
      const grid = (kpi.totalEnergyStoredInGrid / total) * 100;

      return [
        {
          id: 1,
          label: "solar",
          color: "#FAD152",
          value: total > 0 ? parseFloat(solar) : 100,
        },
        {
          id: 2,
          label: "grid",
          color: "#085054",
          value: parseFloat(grid),
        },
      ];
    }

    if (title === "total energy consumed") {
      const total =
        kpi.totalEnergyConsumedBySolar + kpi.totalEnergyConsumedByGrid;

      const solar = (kpi.totalEnergyConsumedBySolar / total) * 100;
      const grid = (kpi.totalEnergyConsumedByGrid / total) * 100;

      return [
        {
          id: 1,
          label: "solar",
          color: "#FAD152",
          value: total > 0 ? parseFloat(solar) : 100,
        },
        {
          id: 2,
          label: "grid",
          color: "#085054",
          value: parseFloat(grid),
        },
      ];
    }

    return [];
  };

  return (
    <div className="w-full h-[112px] bg-background-white border-[0.5px] border-light-grey p-4 rounded-md relative">
      <div className="flex items-center gap-x-2">
        <div className="w-[38px] h-[38px] flex items-center justify-center bg-primary rounded-full">
          {icon}
        </div>

        <p className="font-aileron text-xs font-normal text-dark-gray capitalize">
          {title}
        </p>
      </div>

      <p className="mt-1.5 ml-[46px] font-poppins font-semibold text-2xl">
        {getFormatedFloat(getValue(), 0)}
        <span className="ml-1 font-[250] text-dark-gray">KWh</span>
      </p>

      {title !== "total energy produced" && (
        <div className="absolute right-4 bottom-4 flex items-center gap-x-6">
          <PieChart data={getPieChartData()} />

          <div>
            <div className="flex items-center gap-x-2">
              <SolarIcon />

              <p className="font-aileron font-normal text-sm text-dark-gray">
                {title === "total energy stored"
                  ? getFormatedFloat(kpi?.totalEnergyStoredInSolar, 0) || 0
                  : getFormatedFloat(kpi?.totalEnergyConsumedBySolar, 0) ||
                    0}{" "}
                kWh
              </p>
            </div>

            <div className="mt-2 flex items-center gap-x-2">
              <PowerGridIcon />

              <p className="font-aileron font-normal text-sm text-dark-gray">
                {title === "total energy stored"
                  ? getFormatedFloat(kpi?.totalEnergyStoredInGrid, 0) || 0
                  : getFormatedFloat(kpi?.totalEnergyConsumedByGrid, 0) ||
                    0}{" "}
                kWh
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const KPIs = () => {
  return (
    <div className="flex items-center justify-between w-full p-6 gap-x-6">
      <Container
        title="total energy produced"
        icon={<SolarIcon size={16} className="text-kpi-details-icon" />}
      />

      <Container
        title="total energy stored"
        icon={<EnergyStoredIcon size={16} className="text-kpi-details-icon" />}
      />

      <Container
        title="total energy consumed"
        icon={
          <EnergyConsumedIcon size={16} className="text-kpi-details-icon" />
        }
      />
    </div>
  );
};

export default KPIs;
